import { isObject } from "lodash";
import PromiseOptions from "./PromiseOptions";
import ObjectOptions from "./ObjectOptions";

const Options = ({ options }) => {
  let isPromise = false;

  if (isObject(options)) {
    if (typeof options.then === "function") {
      isPromise = true;
    }
  }

  return isPromise ? PromiseOptions({ options }) : ObjectOptions({ options });
};

export default Options;
